"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReanimatedBottomSheetScrollable = void 0;
const ReanimatedBottomSheetContext_1 = require("./ReanimatedBottomSheetContext");
const useCustomScrollEventsHandlers_1 = require("./_useCustomScrollEventsHandlers/useCustomScrollEventsHandlers");
exports.useReanimatedBottomSheetScrollable = () => {
    const { dispatch } = ReanimatedBottomSheetContext_1.useReanimatedBottomSheet();
    const onContentSizeChange = (_, height) => dispatch({
        type: ReanimatedBottomSheetContext_1.SET_SCROLLABLE_CONTENT_HEIGHT,
        scrollableContentHeight: height,
    });
    const setScrollY = (scrollY) => dispatch({
        type: ReanimatedBottomSheetContext_1.SET_SCROLL_Y_POSITION,
        scrollY,
    });
    const useScrollEventsHandlersHook = (ref, contentOffsetY) => useCustomScrollEventsHandlers_1.useCustomScrollEventsHandlers(ref, contentOffsetY, setScrollY);
    return {
        onScrollableContentSizeChange: onContentSizeChange,
        scrollEventsHandlersHook: useScrollEventsHandlersHook,
    };
};
